export { default as Img200 } from './processed/200/Once-Upon-A-Time-In-Venice.jpg';
export { default as Img400 } from './processed/400/Once-Upon-A-Time-In-Venice.jpg';
export { default as Imgthumb } from './processed/thumb/Once-Upon-A-Time-In-Venice.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/Once-Upon-A-Time-In-Venice.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/Once-Upon-A-Time-In-Venice.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      199,
      104,
      44
    ],
    "_population": 16,
    "_hsl": [
      0.06451612903225805,
      0.6378600823045268,
      0.4764705882352941
    ]
  },
  "LightVibrant": {
    "_rgb": [
      244,
      220,
      132
    ],
    "_population": 642,
    "_hsl": [
      0.13095238095238096,
      0.8358208955223884,
      0.7372549019607844
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      144,
      51,
      20
    ],
    "_population": 28,
    "_hsl": [
      0.04166666666666668,
      0.7560975609756099,
      0.32156862745098036
    ]
  },
  "Muted": {
    "_rgb": [
      152,
      123,
      70
    ],
    "_population": 2243,
    "_hsl": [
      0.10772357723577236,
      0.3693693693693693,
      0.43529411764705883
    ]
  },
  "LightMuted": {
    "_rgb": [
      180,
      172,
      148
    ],
    "_population": 1,
    "_hsl": [
      0.125,
      0.17582417582417587,
      0.6431372549019608
    ]
  },
  "DarkMuted": {
    "_rgb": [
      103,
      83,
      56
    ],
    "_population": 2183,
    "_hsl": [
      0.09574468085106384,
      0.29559748427672955,
      0.31176470588235294
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/Once-Upon-A-Time-In-Venice.js